import {
  HHCollapse,
  HHFormControlLabel,
  HHStack,
  HHSwitch,
  HHTypography,
} from '@hinge-health/react-component-library';
import { useState } from 'react';
import { InternalHoldBaseType } from '../../../types';
import { InternalHoldDetails } from '../internal-hold-details';

interface HoldDetailsProps {
  internalHoldsDetails: InternalHoldBaseType[];
}

const HoldDetails = ({
  internalHoldsDetails,
}: HoldDetailsProps): JSX.Element => {
  const [isHoldsHistoryExpanded, setIsHoldsHistoryExpanded] =
    useState<boolean>(false);
  const { activeHold, holdsHistory } = internalHoldsDetails.reduce<{
    activeHold: InternalHoldBaseType | null;
    holdsHistory: InternalHoldBaseType[];
  }>(
    (acc, hold) => {
      if (hold.clearedAt === null) {
        acc.activeHold = hold;
      } else {
        acc.holdsHistory.push(hold);
      }
      return acc;
    },
    { activeHold: null, holdsHistory: [] },
  );

  return (
    <HHStack spacing={4}>
      <HHStack spacing={1}>
        <HHStack
          spacing={1}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <HHTypography hhVariant="subtitle1">Active Hold</HHTypography>
          <HHFormControlLabel
            control={
              <HHSwitch
                hhVariant="primary"
                onChange={(): void =>
                  setIsHoldsHistoryExpanded(!isHoldsHistoryExpanded)
                }
                checked={isHoldsHistoryExpanded}
              />
            }
            label="Show history"
          />
        </HHStack>
        {activeHold ? (
          <InternalHoldDetails ih={activeHold} />
        ) : (
          <HHTypography hhVariant="muted">No active hold</HHTypography>
        )}
      </HHStack>
      <HHCollapse
        sx={{ '&.MuiCollapse-hidden': { marginTop: 0 } }}
        in={isHoldsHistoryExpanded}
        orientation="vertical"
      >
        <HHStack spacing={2}>
          <HHTypography hhVariant="subtitle1">Holds History</HHTypography>
          {holdsHistory && holdsHistory.length > 0 ? (
            holdsHistory.map(ih => (
              <InternalHoldDetails key={ih.createdAt} ih={ih} />
            ))
          ) : (
            <HHTypography hhVariant="muted">No internal holds</HHTypography>
          )}
        </HHStack>
      </HHCollapse>
    </HHStack>
  );
};

export default HoldDetails;
